import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import ShareLink from "../Shared/ShareLink";

export default function Blogdetails() {
  const [data, setData] = useState([]);
  const [detailsData, setDetailsData] = useState([]);
  const { id } = useParams();

  const blogData = () => {
    axios
      .post(
        "https://m1blog.aaragroups.com/blog/store-based-blog-list-api/",
        { store_id: 4 },

        {
          headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log("RESPONSE ==== : ", res.data?.blog_list);
        setData(res.data?.blog_list);
      })
      .catch((err) => {
        console.log("ERROR: ====", err);
        alert(err.response.data.message);
      });
  };

  const blogDetails = () => {
    axios
      .post(
        "https://m1blog.aaragroups.com/blog/blog-details",
        { id: id },

        {
          headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log("RESPONSE ==== : ", res.data?.blog_list);
        setDetailsData(res.data?.blog_details);
      })
      .catch((err) => {
        console.log("ERROR: ====", err);
        alert(err.response.data.message);
      });
  };
  useEffect(() => {
    blogData();
    blogDetails();
  }, []);
  return (
    <>
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          {detailsData.map((item) => {
            return <title>{item.meta_title}</title>;
          })}
          <link rel="canonical" href="http://mysite.com/example" />
        </Helmet>
      </div>
      <div className="lg:flex lg:px-20 px-5 py-4 hm1 gap-3">
        <div className="border border-white p-3">
          {detailsData?.map((item) => {
            return (
              <div>
                <div className="flex flex-col justify-center items-center">
                  <p className="text-4xl text-orange-400 my-5 text-center">
                    {item.meta_title}
                  </p>
                  <p className="my-5 text-white">{item.meta_title}</p>
                  <img src={item.images} alt="" className="" />
                  <div>
                    <p
                      dangerouslySetInnerHTML={{ __html: item.content }}
                      className="my-5"
                    ></p>
                  </div>
                </div>
                <ShareLink
                  url={window.location.href}
                  variantImage={item.images}
                  variantName={item.Title}
                />
              </div>
            );
          })}
        </div>

        <div className="flex flex-col w-full text-white my-10 ">
          <p className="text-center font-bold text-xl border-b-2 border-white">
            RECENT POST
          </p>
          {data.map((item) => {
            return (
              <div className="flex my-5 flex-row border-b-2">
                <img className="h-32 w-40" src={item.images} alt="" />
                <div>
                  <p className=" px-1 py-1">{item.title.slice(0, 50)}</p>
                  <p className="text-sm px-1 py-1">
                    {item.meta_description.slice(0, 50)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {detailsData.map((item) => {
        return;
      })}
      <div className="bg-white h-28"></div>
    </>
  );
}
